import { Images } from 'assets/images';
import { NavLink } from 'react-router-dom';
import { ROUTES } from 'utils/routeNames';
import { StyledLogoImage } from './styled';

export const Logo = ({ setIsOpen }) => (
  <NavLink onClick={() => setIsOpen(false)} to={ROUTES.WELCOME}>
    <StyledLogoImage src={Images.logo} alt="logo" />
  </NavLink>
);
